import styled, { css } from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';
import { mediaQuery } from '~/src/styles/mixins';
import { FONTS } from '~/src/styles/style-helpers/font-helper';
import { MAX_567 } from '~/src/styles/tokens/break-points';
import { COLORS } from '~/src/styles/tokens/colors';

export const AdditionallyBlockContainer = styled.div`
    flex-direction: column;
    gap: ${rem(24)};
    width: 100%;

    ${mediaQuery(
        { maxWidth: MAX_567 },
        css`
            gap: ${rem(20)};
        `,
    )};
`;

export const TextWrap = styled.span`
    display: inline-block;
    margin-left: ${rem(8)};
    ${FONTS.sans.regular.size17};
`;

export const InlineBlockSpan = styled.span`
    display: inline-block;
`;

export const Plus = styled.img`
    width: ${rem(16)};
    height: ${rem(16)};
`;

export const TextButton = styled.div`
    width: fit-content;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    color: ${COLORS.textPrimaryLink};
    ${FONTS.sans.regular.size17};
    cursor: pointer;
`;
